import React from 'react';
import { Button, colors, useEventListener } from '@equinor/opt-ui-core';
import { Check } from '@equinor/opt-ui-icons';
const submitButtonAriaLabel = 'Submit';
const SubmitButton = ({ formRef, submitButtonText = 'Apply', compact = false, loading = false, disabled, isError = false, onSubmit, ...otherProps }) => {
    const handleKeyDown = (event) => {
        if (disabled || event.key !== 'Enter')
            return;
        const target = event.target;
        if (target.tagName === 'BUTTON' && target?.ariaLabel !== submitButtonAriaLabel)
            return;
        if (target.tagName === 'INPUT' && target.ariaExpanded === 'true')
            return;
        onSubmit();
    };
    useEventListener('keydown', handleKeyDown, formRef);
    if (compact) {
        return (React.createElement(Button, { ...otherProps, compact: true, variant: disabled ? 'ghost' : 'outlined', loading: loading, disabled: disabled, startIcon: React.createElement(Check, { size: 24, color: isError ? colors.energeticred : disabled ? colors.greenMint : undefined }), onClick: onSubmit, "aria-label": submitButtonAriaLabel }));
    }
    return (React.createElement(Button, { ...otherProps, loading: loading, disabled: disabled, onClick: onSubmit, "aria-label": submitButtonAriaLabel }, submitButtonText));
};
export default SubmitButton;
